import styled from "styled-components";

import { colors, globalStyle } from "components";

export const ContainerGeral = styled.div`
  position: absolute;
  background: ${colors.default_base_white};
  opacity: 0.4;
  width: 100%;
  height: 100vh;
  z-index: 1;
`;

export const Container = styled.div`
  position: absolute;
  align-items: center;
  left: 50%;
  padding: 8px 16px;
  transform: translateX(-50%);
  background: #fbe4b6;
  border: 1px solid ${colors.default_base_orange};
  display: flex;
  margin-top: 10px;
  border-radius: 8px;
  transition: 0.3s;
  z-index: 1000;

  span {
    font-family: ${globalStyle.fontFamily};
    font-size: 14px;
    font-weight: 600;
  }

  div {
    margin-left: 10px;
  }
`;
